import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import ProjectService from '../../../services/ProjectService'

type CreateProjectPayload = {
  organization: string
  name: string
}

export const useCreateProject = () => {
  const { org } = useParams()
  const queryClient = useQueryClient()

  return useMutation<any, Error, CreateProjectPayload>({
    mutationKey: ['create-project'],
    mutationFn: ({ organization, name }) => ProjectService.addProject(organization, name),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projects', org] })
      queryClient.invalidateQueries({ queryKey: ['projects-structure'] })
    },
  })
}
